import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import { postRequest, getRequest } from 'services/ApiService.js';
import { url_rest, types } from 'configuration'

class NavN1 extends Component {

  constructor(props) {
    super(props);
    this.getTypes = this.getTypes.bind(this);
    this.navCard = this.navCard.bind(this);
    this.state = {
      types: ''
    }
  }

  navCard(type) {
    var icon = types[type].icon;
    var label = types[type].label[this.props.lang];
    var slug = types[type].slug[this.props.lang]
    return (
      <div onClick={(e) => {this.props.history.push(this.props.history.location.pathname.replace(/\/$/,'')+"/"+slug);}} className="card-lvl-1">
        <i className={"fas " + icon + " fa-5x nav-icon-item"}></i>
        <p>{label}</p>
      </div>
    );
  }

  getTypes() {
    if (this.props.contentType == "destinos") {
      return this.getMunicipalityTypes();
    } else if (this.props.contentType == "recursos") {
      return this.getResourceTypes();
    }
  }

  getMunicipalityTypes() {
    var result = new Set();
    var dataMunicipality = {
      "item_number": 0,
      "page_size": 100,
      "filters": {
        "slug": this.props.queryTerm
      }
    };

    postRequest(url_rest + "/territory/paginated", dataMunicipality, this.props.lang).then(
      (response) => {
        //Obtenemos el ID del territorio a través de su slug
        var itemNumber = 0;
        var pageSize = 1000;
        var dataResources = {
          "filters": {
            "resources.territories.id": response.data.list[0].id
          }
        };
        
        postRequest(url_rest + "/resource_type/paginated", dataResources, this.props.lang).then(values => {
          values.data.list.map(
            element => {
              result.add(element.parent_type.code);
            });
          this.setState({ types: result });
        });
      });
  }

  getResourceTypes(term) {
    var result = new Set();
    var dataResource = {
      "item_number": 0,
      "page_size": 20,
      "filters": {
        "slug": this.props.queryTerm
      }
    };

    postRequest(url_rest + "/resource/paginated", dataResource, this.props.lang).then(
      (response) => {
        getRequest(url_rest + "/resource/get/" + response.data.list[0].id, this.props.lang).then(response => {
          postRequest(url_rest + "/resource/nearby", {
            "radius": 1000,
            "x": response.data.x_coord,
            "y": response.data.y_coord
          }, this.props.lang).then(response => {
            var promises = []
            for (let i = 0; i < response.data.list.length; i++) {
              promises.push(getRequest(url_rest + "/resource/get/" + response.data.list[i].id, this.props.lang))
            }
            Promise.all(promises).then(resouces => {
              resouces.map(resource => {
                // if (resource.data.resource_state.code == "ESTREPUBLICADO") {
                result.add(resource.data.resource_type.code)
                // }
              })
              this.setState({ types: result })
            })
          })
        })
      });
  }

  componentDidMount() {
    this.getTypes();
  }

  render() {
    if (this.state.types != '') {
      return (
        <div className="cards-lvl-1-content">
          {Array.from(this.state.types).map(value => this.navCard(value))}
        </div>
      );
    } else {
      return ("");
    }
  }
}

export default withRouter(NavN1)


// WEBPACK FOOTER //
// ./src/components/NavN1.jsx